export default class UrlHashWatcher {
	static getInstance() {
		return UrlHashWatcher.instance || new UrlHashWatcher()
	}

	constructor() {
		this.listeners = []
		this.parameters = {}
		this.readUrl()
		this.start()
	}
	start() {
		window.addEventListener("hashchange", this.onChange.bind(this))
	}
	stop() {
		window.removeEventListener("hashchange", this.onChange.bind(this))
	}
	readUrl() {
		this.parameters = window.location.hash
			.replace(/^\#(\/|)/, "")
			.split("&")
			.reduce((p, c) => {
				let [key, val] = c.split("=")
				if (key == "") return p

				p[key] = val
				return p
			}, {})
		return this.parameters
	}
	buildHash(params) {
		return "#/" + Object
			.entries(params)
			.filter(([key, val]) => val != null && val != "")
			.map(([key, val]) => {
				return key + "=" + val
			})
			.join("&")
	}
	change(params) {
		Object.assign(this.parameters, params)
		window.location.hash = this.buildHash(this.parameters)
	}
	addListener(fnc) {
		this.listeners.push(fnc)
	}
	removeListener(fnc) {
		let idx = this.listeners.indexOf(fnc)
		if (idx >= 0) {
			this.listeners.splice(idx, 1)
		}
	}
	onChange() {
		this.readUrl()
		this.listeners
			.forEach(f => f(this.parameters, this))
	}
}